import axios from 'axios';

const anowApiRequest = (
  options = {
    url: '/orders',
    body: null,
  },
  method = 'GET',
) => axios({
  method,
  url: options.url,
  headers: {
    Pragma: 'no-cache',
  },
  baseURL: `${process.env.FILES_API}`,
  body: options.body,
  withCredentials: true,
});

export const anowApiPostRequest = (options = {
  url: '/orders',
  body: null,
  companyHash: null,
}) => {
  const companyHashKey = window.isAuthenticated ? 'x-target-company-hash' : 'x-company-hash';
  return axios.post(`${process.env.FILES_API}${options.url}`, options.body, {
    headers: {
      'Content-Type': 'application/json',
      [companyHashKey]: options.companyHash,
    },
    withCredentials: true,
  });
};

export const anowVendorApiRequest = (
  options = {
    url: '/orders',
    body: null,
  },
  method = 'GET',
) => axios({
  method,
  url: options.url,
  baseURL: `${process.env.VENDOR_BASE_URL}`,
  headers: {
    Pragma: 'no-cache',
  },
  data: options.body,
  withCredentials: true,
  timeout: 15000,
});

export default anowApiRequest;
